import React from 'react';
import Dropdown from './Dropdown';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  testKlass: {
    backgroundColor: theme.colors?.primary,
  },
}));

const TestContainerForReact = (props) => {
  const classes = useStyles();
  return (
    <div className="section">
      <div className={classes.testKlass}>
        <Dropdown
          options={[
            'Populära',
            'Rekommenderade',
            'Namn A-Ö',
            'Namn Ö-A',
            'Pris: Lågt till Högt',
            'Pris: Högt till Lågt',
          ]}
        />
      </div>
    </div>
  );
};

export default TestContainerForReact;
